import { Tip } from '@ofself/shell'

export default function AuditBadge() {
  return (
    <Tip label="Audit trail recorded via Paradigm SDK">
      <span className="audit-badge">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      </span>
    </Tip>
  )
}
